var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fixed top-0 bottom-0 left-0 right-0 flex flex-col items-center justify-center text-primary"},[_c('icon-base',{attrs:{"size":16}},[_c('icon-vivizinho')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }